import type { Player } from '@shared-types/match.types';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, compApiUrl } from '@utilities/WindowContext';

export const fetchPlayersById = (params: { playerIds: string[]; competitionContext?: string }, signal?: AbortSignal) =>
  loadFromAPIs<Player[]>('v2/players', params, { apiKey, apiUrl: compApiUrl, signal });
